import { AxiosResponse } from 'axios'
import { httpAnalitcs } from '../api'
import { Grupos } from '../models'

const controller = 'grupos'

export async function getGruposAll(page: number, size: number, term?: string, sort: any = { archived: "asc", id: "desc" }): Promise<any> {
    const stringSort = Object.keys(sort).map(b => `${b}:${sort[b]}`).join(',')
    const { data } = await httpAnalitcs.get<Grupos[], AxiosResponse>(`${controller}?page=${page}&size=${size}&archived=0${(term ? `&nome=${term}` : "")}&sort=${stringSort}`);
    return data;
}

export async function getGrupo(id: string): Promise<Grupos> {

    const { data } = await httpAnalitcs.get<Grupos, AxiosResponse>(`${controller}/${id}`)
    return data;
}

export async function postGrupo(payload: Grupos): Promise<Grupos> {

    const { data } = await httpAnalitcs.post<Grupos, AxiosResponse>(`${controller}`, payload)
    return data;
}

export async function putGrupo(payload: Grupos): Promise<Grupos> {

    const { data } = await httpAnalitcs.put<Grupos, AxiosResponse>(`${controller}/${payload.id}`, payload);
    return data;
}

export async function deleteGrupo(grupoId: string): Promise<boolean> {

    const { status } = await httpAnalitcs.delete(`${controller}/${grupoId}`);

    return status === 204;
}

// export async function patchGrupo(payload: Grupos): Promise<AxiosResponse> {
//     return await httpAnalitcs.patch(`${controller}/${payload.id}`, payload)
// }